<template>
  <page-layout :title="title">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li class="is-active"><a href="#">Lives</a></li>
    </template>
    <div class="columns is-mobile is-justify-content-space-between mb-4">
      <div class="column is-narrow-tablet">
        <b-button expanded tag="router-link" type="is-success" :to="{ name: 'live.add' }">
          <b-icon icon="plus" size="is-small" />
          <span>Nouveau</span>
        </b-button>
      </div>
      <div class="column is-narrow-tablet">
        <b-button expanded tag="router-link" type="is-success" :to="{ name: 'live.setup' }">
          <b-icon icon="plus" size="is-small" />
          <span class="is-hidden-mobile">Importer depuis Jotform</span>
          <span class="is-hidden-tablet">Importer</span>
        </b-button>
      </div>
    </div>
    <list-lives-filter :administrators="administrators" class="mb-4" />
    <list-lives-table
      :lives="liveList"
      :administrators="administrators"
      :loading="loading"
      @delete="deleteLive"
    />
  </page-layout>
</template>

<script>
import { mapActions } from 'vuex'
import { stringNormalizer } from '@helpers/stringNormalizer'
import PageLayout from '@components/PageLayout.vue'
import ListLivesTable from '@views/pages/ListLivesPage/ListLivesTable.vue'
import ListLivesFilter from '@views/pages/ListLivesPage/ListLivesFilter.vue'

export default {
  name: 'ListLivesPage',

  components: {
    ListLivesFilter,
    ListLivesTable,
    [PageLayout.name]: PageLayout,
  },

  data() {
    return {
      title: 'Liste des lives',
      loading: true,
      lives: [],
      administrators: [],
    }
  },

  async mounted() {
    await this.load()
  },

  computed: {
    liveList() {
      return this.lives.filter((live) => {
        let condition = true

        if (this.$route.query?.keyword) {
          const term = stringNormalizer(this.$route.query.keyword.toLowerCase())
          const name = stringNormalizer(live.name.toLowerCase())

          condition = condition && name.indexOf(term) >= 0
        }

        if (this.$route.query?.status) {
          condition = condition && this.$route.query?.status === live.status
        }

        if (this.$route.query?.visitorAccessType) {
          condition = condition && this.$route.query?.visitorAccessType === live.visitorAccessType
        }

        if (this.$route.query?.administrator) {
          condition = condition && this.$route.query?.administrator === live.administratorId
        }

        return condition
      })
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async load() {
      this.loading = true

      await Promise.all([this.fetchLive(), this.fetchAdministrators()])

      this.loading = false
    },

    async fetchLive() {
      try {
        this.lives = await this.$services.liveService.getAll()
      } catch (err) {
        this.addToastMessage({
          text: err.message ? err.message : 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },

    async fetchAdministrators() {
      try {
        this.administrators = await this.$services.administratorService.getAll()
      } catch (err) {
        this.administrators = []
        console.error(err)
      }
    },

    async deleteLive(live) {
      this.loading = true

      try {
        const liveDeleted = await this.$services.liveService.delete(live.id)
        this.lives = this.lives.filter((live) => live.id !== liveDeleted.id)

        this.addToastMessage({
          text: `Le live "${liveDeleted.name}" a été supprimé.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ? err.message : 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
      }

      this.loading = false
    },
  },
}
</script>
